const MIME_EXTENSION_MAP: Record<string, string> = {
  // --- Documents bureautiques ---
  "application/pdf": ".pdf",

  "application/msword": ".doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    ".docx",

  "application/vnd.ms-excel": ".xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
  "text/csv": ".csv",

  "application/vnd.ms-powerpoint": ".ppt",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    ".pptx",

  // OpenDocument
  "application/vnd.oasis.opendocument.text": ".odt",
  "application/vnd.oasis.opendocument.spreadsheet": ".ods",
  "application/vnd.oasis.opendocument.presentation": ".odp",

  // --- Texte / Web ---
  "text/plain": ".txt",
  "text/html": ".html",
  "text/css": ".css",
  "text/javascript": ".js",
  "application/javascript": ".js",
  "application/json": ".json",
  "application/xml": ".xml",
  "text/xml": ".xml",
  "text/markdown": ".md",
  "application/x-yaml": ".yaml",
  "text/yaml": ".yaml",
  "text/x-yaml": ".yaml",

  // --- Images ---
  "image/jpeg": ".jpg",
  "image/jpg": ".jpg",
  "image/pjpeg": ".jpg",
  "image/png": ".png",
  "image/gif": ".gif",
  "image/bmp": ".bmp",
  "image/webp": ".webp",
  "image/svg+xml": ".svg",
  "image/tiff": ".tif",
  "image/x-icon": ".ico",
  "image/vnd.microsoft.icon": ".ico",

  // --- Audio ---
  "audio/mpeg": ".mp3",
  "audio/mp3": ".mp3",
  "audio/mp4": ".m4a",
  "audio/aac": ".aac",
  "audio/wav": ".wav",
  "audio/x-wav": ".wav",
  "audio/ogg": ".ogg",
  "audio/flac": ".flac",
  "audio/webm": ".weba",
  "audio/midi": ".mid",
  "audio/x-midi": ".mid",

  // --- Vidéo ---
  "video/mp4": ".mp4",
  "video/x-msvideo": ".avi",
  "video/x-ms-wmv": ".wmv",
  "video/quicktime": ".mov",
  "video/mpeg": ".mpeg",
  "video/ogg": ".ogv",
  "video/webm": ".webm",

  // --- Archives / compressés ---
  "application/zip": ".zip",
  "application/x-zip-compressed": ".zip",
  "multipart/x-zip": ".zip",

  "application/x-7z-compressed": ".7z",
  "application/x-rar-compressed": ".rar",
  "application/vnd.rar": ".rar",

  "application/x-tar": ".tar",
  "application/gzip": ".gz",
  "application/x-gzip": ".gz",
  "application/x-bzip2": ".bz2",

  // --- Fonts ---
  "font/ttf": ".ttf",
  "font/otf": ".otf",
  "font/woff": ".woff",
  "font/woff2": ".woff2",
  "application/font-woff": ".woff",
  "application/font-woff2": ".woff2",

  // --- Autres courants ---
  "application/octet-stream": "", // binaire générique, pas d’extension fiable
};

export function getExtensionFromBlobType(typeOrBlob: Blob | string): string {
  const rawType =
    typeof typeOrBlob === "string" ? typeOrBlob : typeOrBlob.type || "";

  if (!rawType) return "";

  // on enlève les paramètres éventuels, ex: "application/pdf; charset=utf-8"
  const cleanType = rawType.split(";")[0].trim().toLowerCase();

  // recherche directe dans la map
  if (MIME_EXTENSION_MAP[cleanType]) {
    return MIME_EXTENSION_MAP[cleanType];
  }

  // fallback simple sur les préfixes (au cas où)
  if (cleanType.startsWith("text/")) return ".txt";
  if (cleanType.startsWith("image/")) return ".img";
  if (cleanType.startsWith("audio/")) return ".audio";
  if (cleanType.startsWith("video/")) return ".video";

  return "";
}
